import { ContentLayoutVariant } from '@silvertours/common-landingpages-view';

type StageVariantConfig = {
  isMinimal: boolean;
  isPlain: boolean;
  isErrorPage: boolean;
  isPromoPage: boolean;
  showImage: boolean;
  searchDisplayMode: 'full' | 'thin';
  isModernStage: boolean;
};

export const resolveStageVariantConfig = (
  variant: ContentLayoutVariant,
): StageVariantConfig => {
  switch (variant.kind) {
    case 'default':
    case 'reviewsPillar':
      return {
        isMinimal: false,
        isPlain: false,
        isErrorPage: false,
        isPromoPage: false,
        showImage: true,
        searchDisplayMode: 'full',
        isModernStage: false,
      };
    case 'plain':
      return {
        isMinimal: false,
        isPlain: true,
        isErrorPage: false,
        isPromoPage: false,
        showImage: true,
        searchDisplayMode: 'full',
        isModernStage: false,
      };
    case 'promo':
      return {
        isMinimal: false,
        isPlain: true,
        isErrorPage: false,
        isPromoPage: true,
        showImage: true,
        searchDisplayMode: 'full',
        isModernStage: false,
      };
    case 'minimal':
      return {
        isMinimal: true,
        isPlain: false,
        isErrorPage: false,
        isPromoPage: false,
        showImage: variant.searchMask !== 'thin',
        searchDisplayMode: variant.searchMask === 'thin' ? 'thin' : 'full',
        isModernStage: false,
      };
    case 'error':
      return {
        isMinimal: false,
        isPlain: false,
        isErrorPage: true,
        isPromoPage: false,
        showImage: true,
        searchDisplayMode: 'full',
        isModernStage: false,
      };
    case 'sea':
      return {
        isMinimal: false,
        isPlain: false,
        isErrorPage: false,
        isPromoPage: false,
        showImage: false,
        searchDisplayMode: 'full',
        isModernStage: true,
      };
    default: {
      const unhandledVariant: never = variant;
      throw new Error(`Unhandled variant: ${unhandledVariant}`);
    }
  }
};
